import { setPageStep, setResetState, setResetTrainerInfo } from '../trainer'
import { resetSessionStats } from '../trainerSession'
import { actions as trainerSettingActions } from '../trainerSettings'

export const exitFromTrainer = (dispatch, index = 0) => {
	dispatch(setPageStep('settings', index))
	dispatch(setResetTrainerInfo())
	dispatch(setResetState(null, index))
	dispatch(resetSessionStats())
	dispatch(trainerSettingActions.setResetSettingsFilter())
	dispatch(trainerSettingActions.setConfigurationId(null))
	dispatch(trainerSettingActions.setSpotLines(null))
	dispatch(trainerSettingActions.setCrossFilters(null))
	dispatch(trainerSettingActions.setResetConfigDescription())
	dispatch(trainerSettingActions.setFilterByHands(null))
	dispatch(trainerSettingActions.setHandsCountByFilter(null))
	dispatch(trainerSettingActions.setEquityThreshold([0, 100]))
	dispatch(trainerSettingActions.setEVThreshold([0, 100]))
	dispatch(trainerSettingActions.setHandRange([0, 100]))
}
